export const PoiTypeEnum = Object.freeze({
    start :'start',
    middle:'middle',
    end:'end'
})